import { render, staticRenderFns } from "./Task.vue?vue&type=template&id=fb82195a&scoped=true&"
import script from "./Task.vue?vue&type=script&lang=ts&"
export * from "./Task.vue?vue&type=script&lang=ts&"
import style0 from "./Task.vue?vue&type=style&index=0&id=fb82195a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb82195a",
  null
  
)

export default component.exports